import styled from "styled-components";
import globalStyles from "../../constants/globalStyles/theme.json";
import { Link } from "react-router-dom";

const { colors, spacing, breakpoints } = globalStyles;

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 350px;
  background-color: ${colors.primary.green};
  box-sizing: border-box;
  overflow-x: hidden;

  @media (max-width: ${breakpoints.m}) {
    height: 450px;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1400px;
  margin: auto auto;
  padding: 0 ${spacing.space32};
  box-sizing: border-box;

  h3 {
    font-family: "Roboto", sans-serif;
    color: ${colors.primary.offWhite};
    font-size: 1.5rem;
  }

  @media (max-width: ${breakpoints.m}) {
    padding: 0 ${spacing.space24};
  }
`;

export const FooterText = styled.div`
  display: flex;
  flex-direction: column;
  color: ${colors.primary.offWhite};
  font-size: 1.2rem;
  margin-top: ${spacing.space4};

  a {
    color: ${colors.primary.offWhite};
    text-decoration: none;
  }

  a:hover {
    text-underline-offset: ${spacing.space4};
    text-decoration: underline;
    text-decoration-thickness: ${spacing.space2};
  }
`;

export const SocialMediaContainer = styled.div`
  display: flex;
  margin-left: auto;
  margin-top: auto;

  @media (max-width: ${breakpoints.m}) {
    margin-left: 0;
    margin-top: ${spacing.space32};
  }
`;

export const StyledIcon = styled.a`
  color: ${colors.primary.offWhite};
  margin: 0 ${spacing.space16};
  cursor: pointer;
  border: 1px solid ${colors.primary.offWhite};
  border-radius: 50%;
  padding: ${spacing.space8};
  justify-content: center;
  align-items: center;
  display: flex;
  transition: all 0.3s ease;

  &:hover {
    color: ${colors.primary.green};
    background-color: ${colors.primary.offWhite};
    border-color: ${colors.primary.darkGreen};
    transform: scale(1.1);
  }

  @media (max-width: ${breakpoints.m}) {
    margin: 0 ${spacing.space8};

    &:first-child {
      margin-left: 0;
    }
  }
`;

export const NavLink = styled(Link)`
  text-decoration: none;
  color: ${colors.typography.offWhite};
  padding: ${spacing.space4} ${spacing.space16};
  font-size: 1.125rem;

  &:hover {
    text-decoration: none;
    background-color: ${colors.primary.offWhite};
    border-radius: 5px;
    color: ${colors.primary.green};
  }
`;

export const RowLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: ${spacing.space32};
  margin-bottom: ${spacing.space32};

  @media (max-width: ${breakpoints.m}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const FooterLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colors.primary.offWhite};
  max-width: 1400px;
`;

export const NavbarLogoContainer = styled(Link)`
  display: flex;
  margin-right: ${spacing.space32};
`;

export const NavbarLogo = styled.img`
  height: 110px;
  width: 155px;

  @media (max-width: ${breakpoints.m}) {
    height: 90px;
    width: 125px;
  }
`;

export const FooterTextContent = styled.div`
  h3 {
    margin-bottom: -${spacing.space2};
  }
`;
